import { memo } from 'react';
import styled from '@emotion/styled';
import { Link, type LinkProps } from '../presentation/Link';

type Props = LinkProps & {
  baseUrl?: string;
};

export const MessageCitationMaybeLink = memo(({ baseUrl, ...props }: Props) => {
  if (!props.to) {
    return <>{props.children}</>;
  }

  const link = props.to.toString();

  const isAbsolute = link.startsWith('http');

  let absoluteUrl: string | null;
  if (isAbsolute) {
    absoluteUrl = link;
  } else if (baseUrl) {
    absoluteUrl = `${baseUrl}${link}`;
  } else {
    const windowBaseUrl = window?.location?.origin;
    absoluteUrl = windowBaseUrl ? `${windowBaseUrl}${link}` : null;
  }

  if (absoluteUrl) {
    return (
      <StyledAnchor href={absoluteUrl} target="_blank" rel="noreferrer">
        {props.children}
      </StyledAnchor>
    );
  }

  return <Root {...props}>{props.children}</Root>;
});

const StyledAnchor = styled.a(({ theme }) => ({
  display: 'inline-flex',

  '&:hover div': {
    color: theme.palette.hyperlink,
    textDecoration: 'underline',
  },
}));

const Root = styled(Link)(({ theme }) => ({
  display: 'inline-flex',

  '&:hover div': {
    color: theme.palette.hyperlink,
    textDecoration: 'underline',
  },
}));
